const DEED_FILINGS_CSV_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vR9hfr_B_AXS4wrHb3q3k32xFlZHhVrGCkFpH-HrNy4C_bcWGsqYoyWDZuS1cBFb7WtTm97kntOm5jP/pub?output=csv';

/** Parses "M/D/YY" (as published by Google Sheets) into an ISO "YYYY-MM-DD" string. */
function toIsoDate(value: string): string | null {
  const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{2})$/);
  if (!match) return null;
  const [, m, d, yy] = match;
  const year = 2000 + Number(yy);
  return `${year}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
}

/**
 * Deed filings live in a public Google Sheet (published as CSV), not Salesforce.
 * Sheet is pre-aggregated as one row per week: "Week Ending,Filings" — so this
 * feeds the weekly-metrics engine as a 'sum' aggregation, not a per-row 'count'.
 */
export async function fetchDeedFilings(
  _startDate: string,
  signal?: AbortSignal
): Promise<Record<string, unknown>[]> {
  const res = await fetch(DEED_FILINGS_CSV_URL, { signal });
  if (!res.ok) throw new Error(`Failed to fetch deed filings sheet: ${res.status}`);
  const text = await res.text();

  const lines = text.trim().split('\n').slice(1); // drop header row
  const out: Record<string, unknown>[] = [];
  for (const line of lines) {
    const [rawDate, rawFilings] = line.split(',');
    const weekEnding = toIsoDate(rawDate ?? '');
    const filings = Number(rawFilings);
    if (!weekEnding || rawFilings == null || rawFilings.trim() === '' || isNaN(filings)) continue;
    out.push({ weekEnding, filings });
  }
  return out;
}
